import type { MessageValue } from 'contexts/intl/intlContext';
import type { IntlKey } from 'locales';
import { connect } from 'react-redux';
import * as ProductModificationSelectors from 'state/productModificationForm/productModificationForm.selector';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

const defaultTechnicalErrorKey: IntlKey = 'quote.errorMessages.TechnicalError';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  message: string;
  values?: Record<string, MessageValue>;
}

export type ErrorState = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const technicalError = ProductModificationSelectors.getTechnicalError(state, tabId);

  if (!technicalError || !technicalError.message) {
    return {
      message: defaultTechnicalErrorKey,
    };
  }

  return {
    message: technicalError.message,
  };
};

export const connectError = connect(mapStateToProps);
